"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _constructor = _interopRequireDefault(require("../../../constants/constructor"));

/* istanbul ignore file */
class RouteWithIdDecorator {
  [_constructor.default]() {
    this.id = null;
  }
  /**
   * @return {string}
   */


  getId() {
    return this.id;
  }
  /**
   * @param {string} id
   */


  setId(id) {
    this.id = id;
    return this;
  }

}

exports.default = RouteWithIdDecorator;